import React, { JSX } from 'react';
import { useLocation, useNavigate } from 'react-router';

/**
 * Is needed as long as we did not change all components to functional components,
 * as useLocation and useNavigate can't be used by these.
 * @param Component
 * @returns {function(*)}
 */
export function withRouter<T>(Component: React.ComponentType<T>): (props: T) => JSX.Element {
  // eslint-disable-next-line react/display-name
  return function (props: T): JSX.Element {
    return <Component {...props} navigate={useNavigate()} location={useLocation()} />;
  };
}
